import React from 'react';

export default function PortalHero({ badge, title, titleHighlight, subtitle, children }) {
  return (
    <section className="portal-hero px-5 py-16 sm:px-8 sm:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="max-w-4xl">
          {badge && <div className="portal-eyebrow mb-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em]">{badge}</div>}
          <h1 className="text-4xl font-semibold leading-[1.08] tracking-[-0.035em] text-slate-950 sm:text-6xl">
            {title}
            {titleHighlight && <><br /><span className="text-violet-700">{titleHighlight}</span></>}
          </h1>
          {subtitle && <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-500">{subtitle}</p>}
          {children}
        </div>
      </div>
    </section>
  );
}
